/**
 * 验证手机格式
 * @param {*} tel
 */
export const isTel = tel =>
    /(^[1][2,3,4,5,6,7,8,9][0-9]{9}$)|(^[2,8,6][0-9]{7}$)|(^[2,3,5,6,9][0-9]{7}$)/.test(
        tel
    );

/**
 * 判断微信浏览器
 */
export const isWechat = () =>
    navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;

// 匹配QQ与TIM
export const isQQ = () => {
    const u = navigator.userAgent;
    let match = u.match(/QQ\//i);
    match = match ? match[0] : false;
    return match == "QQ/";
};

// 判断是否移动端
export const isMobile = function () {
    return !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/);
};

/**
 * 验证身份证号码
 * @param {*} idcard
 */
export const isIdcard = idcard =>
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
        idcard
    );
